import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues, getInfoIssues } from '../../../../../../../utils/validationSummary';

/**
 * !! HAS A MODERN TWIN: projectProperties/modern/PropertyPicker.jsx !!
 *
 * That file is a verbatim copy of everything in this class except render(). Any change
 * to the state machine, the handlers or componentDidUpdate MUST be mirrored there, or
 * the two will drift and screens will behave differently depending on which variant
 * they import. Only the layout is allowed to differ.
 *
 * This duplication is temporary: see the note in modern/PropertyPicker.jsx for how to
 * collapse the two once the modern layout has settled.
 */
class PropertyPicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.property.value,
            tempValue: this.props.property.value,
            error: +this.props.property.value < this.getMin(this.props.property.value) || +this.props.property.value > this.getMax(this.props.property.value)
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);

        this.getMin = this.getMin.bind(this);
        this.getMax = this.getMax.bind(this);
    }

    getMin(value) {
        return ('' + value) !== this.props.property.valueMeta.off ? +this.props.min : Math.min(this.props.min, this.props.property.valueMeta.off);
    }

    getMax(value) {
        return ('' + value) !== this.props.property.valueMeta.off ? +this.props.max : Math.max(this.props.max, this.props.property.valueMeta.off);
    }

    handleChange(e) {
        const value = +e.target.value;

        this.setState({
            tempValue: ''+value,
        });
    }

    handleKeyUp (e) {
        if (e.target.value === null || e.target.value === undefined || e.target.value === ''|| ((''+this.state.value) === (''+this.state.tempValue))) {
            return;
        }
        const value = this.state.tempValue;
        this.setState({
            value: ''+value,
            error: value < this.getMin(value) || +value > this.getMax(value)
        });

        //Add it to have a generic message in english. The error text, in case the value is out of range, is autogenerated in the language of the pc
        if (!e.target.validity.valid) {
            e.target.title = value < this.getMin(value) ? `Select a value greater than ${this.getMin(value)}` : `Select a value lower than ${this.getMax(value)}`;
        }
        else {
            e.target.title = '';
        }

        this.props.handleChange(this.props.property.info.name, value);
    }

    handleMouseUp(e) {
        if (e.target.value === null || e.target.value === undefined || e.target.value === ''|| ((''+this.state.value) === (''+this.state.tempValue))) {
            return;
        }

        let value = this.state.tempValue;

        //Mirek conversion
        if (this.props.type === "Mirek") {
            value = (+this.state.tempValue) > (+this.state.value)
                ? Math.round(1000000 / (Math.round(1000000 / (+this.state.tempValue)) - 1))
                : Math.round(1000000 / (Math.round(1000000 / (+this.state.tempValue)) + 1));
        }

        this.setState({
            value: ''+value,
            tempValue: ''+value,
            error: value < this.getMin(value) || +value > this.getMax(value)
        });

        //Add it to have a generic message in english. The error text, in case the value is out of range, is autogenerated in the language of the pc
        if (!e.target.validity.valid) {
            e.target.title = value < this.getMin(value) ? `Select a value greater than ${this.getMin(value)}` : `Select a value lower than ${this.getMax(value)}`;
        }
        else {
            e.target.title = '';
        }

        this.props.handleChange(this.props.property.info.name, value);
    }

    componentDidUpdate(prevProps, prevState) {
        if(!(isNaN(this.props.property.value) && isNaN(prevProps.property.value))){
            if (this.props.property.value !== prevProps.property.value) {
                this.setState({ value: this.props.property.value });
            }

            //needed when handleChange is triggered from other component, the props are updated but not the state
            if (this.props.property.value !== prevState.value) {
                this.setState({ value: this.props.property.value });
                this.setState({ tempValue: this.props.property.value });
            }

            if (this.props.property.value !== prevProps.property.value
                || this.props.min !== prevProps.min
                || this.props.max !== prevProps.max) {
                this.setState({ error: +this.props.property.value < this.getMin(this.props.property.value) || +this.props.property.value > this.getMax(this.props.property.value) });
            }

            if (this.props.issues !== prevProps.issues) {
                const infos = getInfoIssues(this.props.issues, this.props.property);
                if (infos.length > 0) {
                    for (var i=0;i<infos.length;i++) {
                        if (infos[i].savedValue != null) {
                            this.setState({
                                value: infos[i].savedValue,
                                tempValue: infos[i].savedValue,
                            });
                        }
                    }
                }
            }
        }
    }

    render() {

        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);

        const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;
        const inputStyleInner = this.props.inputStyleInner || {};

        return (
            <Row style={{ margin: this.props.margin || "0.75rem auto 0", flexWrap: 'nowrap' }}>
                {this.props.title &&
                <Col style={{ paddingLeft: '0', display: "flex" }} sm={this.props.titleSize || 4}>
                    {this.props.title}
                    {/* {this.props.title.replace(/([A-Z])/g, ' $1')} */}
                </Col>
                }

                <Col sm={this.props.inputSize || 5} className={this.props.inputPadding ? this.props.inputPadding : ''} style={{ maxWidth: "6rem", display: "flex", flexDirection: "column", ...(this.props.inputStyle || {}) }}>
                    <input
                        disabled={this.props.disabled}
                        className={className}
                        style={inputStyleInner}
                        name={this.props.property.info.name}
                        type="number"
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        value={Number(this.state.value || this.props.property.value) || 0}
                        onChange ={this.handleChange}
                        onKeyUp={this.handleKeyUp}
                        onMouseUp={this.handleMouseUp} />

                    {getIssuesComponent(errors, warnings)}
                </Col>
                {this.props.measureUnit ? <Col sm={this.props.unitSize || 2} style={{ padding: '0', justifyContent: "center", display: "flex" }}>
                    {this.props.measureUnit}
                </Col> : null}
            </Row>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyPicker);
